var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "download",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10260",
    "data-name": "Rectangle 10260",
    width: 30,
    height: 30,
    rx: 4,
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22691",
    "data-name": "Group 22691",
    transform: "translate(-1813 -148.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_2292",
    "data-name": "Line 2292",
    x2: 12,
    transform: "translate(1822 170.5)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2293",
    "data-name": "Line 2293",
    y2: 10,
    transform: "translate(1828 157.5)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2294",
    "data-name": "Line 2294",
    x2: 5,
    y2: 5,
    transform: "translate(1823 162.5)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2295",
    "data-name": "Line 2295",
    x1: 5,
    y2: 5,
    transform: "translate(1828 162.5)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1.4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.f3a8ab30589ce8a6dac6991c810d5239.svg";
export { ForwardRef as ReactComponent };